// extracted by mini-css-extract-plugin
export default {"component":"Video_component__Nu+c3","fullVariant":"Video_fullVariant__6-rXA"};